module.exports = __webpack_public_path__ + "img/startConfiguration.1daa60d.png";